import { render, staticRenderFns } from "./veStuAssocActivityRecordEdit.vue?vue&type=template&id=42d5a572&scoped=true"
import script from "./veStuAssocActivityRecordEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5a572",
  null
  
)

export default component.exports